export default __webpack_public_path__ + "static/media/dev.14fab3eb.jpg";